import { Fragment, useState } from "react";

import dynamic from "next/dynamic";

import PropTypes from "prop-types";

import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Toast from "components/atoms/Toast";
import EbookModal from "components/molecules/EbookModal";

const PackageModal = dynamic(
  () => import("components/molecules/PackageModal"),
  {
    ssr: false,
  }
);

import styles from "components/molecules/CardPackage/Index.module.scss";
/** ========== */

const ListContent = ({ data, dataSuffix }) => {
  const [modalShow, setModalShow] = useState(false);
  const [ebookModalShow, setEbookModalShow] = useState(false);

  const showEbookBookModal = (hash) => {
    setEbookModalShow(true);
    if (history.pushState) {
      history.pushState(null, null, `#${hash}`);
    }
  };

  return (
    <div className="py-8 px-5">
      <div
        className="relative mt-2 flex pl-4 font-semibold before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-[''] first:mt-0"
        dangerouslySetInnerHTML={{ __html: data.subTitle }}
      ></div>
      {data?.listContent && data?.listContent.length > 0 && (
        <ul className="pl-0.5">
          {data.listContent.map((content, key) =>
            content.checkName || content.ebook_download ? (
              <div key={key}>
                {content.checkName && modalShow && (
                  <Fragment>
                    <Toast>
                      <PackageModal
                        country_name={dataSuffix.name}
                        country_id={dataSuffix.id}
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        suffix_data={dataSuffix.suffixData}
                        isReserved={content.isReserved}
                      />{" "}
                    </Toast>
                  </Fragment>
                )}
                {content.ebook_download && (
                  <Fragment>
                    <Toast>
                      <EbookModal
                        show={ebookModalShow}
                        onHide={() => setEbookModalShow(false)}
                        imgLeft={content.img_left_src || ""}
                        triggerName={content.trigger_name || ""}
                        apiLink={content.api_link || ""}
                        contactFromId={content.contact_from_id || null}
                      />{" "}
                    </Toast>
                  </Fragment>
                )}
                <li
                  key={key}
                  className="relative mt-2 cursor-pointer"
                  id={content.hash_id && content.hash_id}
                  onClick={() => {
                    content.checkName
                      ? setModalShow(true)
                      : content.ebook_download &&
                        showEbookBookModal(content.hash_id);
                  }}
                >
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span
                    className="inline-block pl-7 font-medium text-bbc-primary"
                    dangerouslySetInnerHTML={{
                      __html: content.text,
                    }}
                  ></span>
                  {content.childContent &&
                    content.childContent.map((item1, index1) => {
                      return (
                        <li key={index1}>
                          <span
                            className="inline-block pl-7 font-medium text-bbc-primary"
                            dangerouslySetInnerHTML={{
                              __html: item1,
                            }}
                          ></span>
                        </li>
                      );
                    })}
                </li>
              </div>
            ) : (
              <li className="relative mt-2" key={key}>
                <FaCheck
                  className="absolute top-1.5 left-0 text-bbc-brand-500"
                  size={12}
                />
                <span
                  className="inline-block pl-7"
                  dangerouslySetInnerHTML={{
                    __html: content.text,
                  }}
                ></span>
              </li>
            )
          )}
        </ul>
      )}
    </div>
  );
};
const Component = ({
  price,
  data,
  dataSuffix,
  index,
  entityId,
  dataPackage,
}) => {
  const getKindClass = () => {
    if (index == 0) return "text-bbc-brand-500";
    if (index == 1) return "text-bbc-yellow-500";
  };

  const borderColorClass = () => {
    if (index == 0) return "lg:hover:border-bbc-brand-500";
    if (index == 1) return "lg:hover:border-bbc-yellow-500";
    if (index == 2) return "lg:hover:border-bbc-brand-700";
  };
  const btnColorClass = () => {
    if (index == 0) return `bg-bbc-brand-500  ${styles.btnBlue} `;
    if (index == 1) return `bg-bbc-yellow-500  ${styles.btnYellow}`;
    if (index == 2) return `bg-bbc-brand-700 ${styles.btnDarkBlue}`;
  };

  const [Tab, setTab] = useState(0);
  const { kind, content, member, switchTab } = data;

  const SwitchOrganization = () => {
    setTab(0);
  };
  const SwitchIndividual = () => {
    setTab(1);
  };

  const dataLLC = dataPackage.Packages.filter((el) => el.id == 65);
  const priceLLC = dataLLC[0].Services[0].Fee.value;
  const dataJSC = dataPackage.Packages.filter((el) => el.id == 79);
  const priceJSC = dataJSC[0].Services[0].Fee.value;

  return (
    <div
      className={`group flex h-full flex-col ${
        switchTab ? "" : "justify-between"
      } rounded-3xl border-0  border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 lg:border-4 lg:hover:border-4 ${borderColorClass()} lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]`}
    >
      <div className="h-full">
        <div className="h-full pt-6">
          {switchTab ? (
            <div className="flex h-full w-full flex-col justify-between">
              <div>
                <div>
                  <div id="left-tabs-example">
                    <div className="mb-[10px]">
                      <div className="m-auto flex max-w-fit justify-start rounded-full  border border-[#B7B7B7] border-opacity-70 md:border lg:justify-center">
                        <button
                          className={`relative w-fit cursor-pointer select-none rounded-full py-2 px-4 text-sm font-semibold leading-6 text-bbc-brand-500 ${
                            Tab == 0
                              ? "border border-bbc-brand-500"
                              : "border border-transparent text-bbc-neutral-600 hover:text-bbc-brand-500"
                          }`}
                          onClick={SwitchOrganization}
                        >
                          Organization
                        </button>
                        <button
                          className={`relative w-fit cursor-pointer select-none rounded-full py-2 px-4 text-sm font-semibold leading-6 text-bbc-brand-500 ${
                            Tab == 1
                              ? "border border-bbc-brand-500"
                              : "border border-transparent text-bbc-neutral-600 hover:text-bbc-brand-500"
                          }`}
                          onClick={SwitchIndividual}
                        >
                          Individual
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    {content?.length > 0 &&
                      content?.map((item, index) => {
                        return (
                          <div key={index}>
                            <div
                              className={`${Tab === index ? "none" : "hidden"}`}
                            >
                              <div className=" border-b  border-b-bbc-neutral-500 py-8 text-center">
                                <p className="text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-primary">
                                  <span>US$</span>
                                  {price}
                                  {member && (
                                    <span className="text-base">{member}</span>
                                  )}
                                </p>
                              </div>
                              <ListContent
                                data={item}
                                dataSuffix={dataSuffix}
                              />
                            </div>
                            <div
                              className={`${Tab === index ? "hidden" : "none"}`}
                            >
                              <div className=" border-b  border-b-bbc-neutral-500 py-8 text-center">
                                <p className="text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-primary">
                                  <span>US$</span>
                                  {data.id == 66 ? priceLLC : priceJSC}
                                  {member && (
                                    <span className="text-base">{member}</span>
                                  )}
                                </p>
                              </div>
                              <ListContent
                                data={item}
                                dataSuffix={dataSuffix}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center">
                <a
                  href={`/onboarding/register?country_id=244&entity_type_id=${entityId}&package_id=${
                    Tab == 1 && data.id == 66
                      ? dataLLC[0].id
                      : Tab == 1 && data.id == 80
                      ? dataJSC[0].id
                      : data.id
                  }`}
                  className={` ${
                    styles.btnAnimate
                  } ${btnColorClass()} inline-block w-full cursor-pointer  rounded-full border py-2 px-6 font-normal  text-white`}
                >
                  <span>Get Started</span>
                </a>
              </div>
            </div>
          ) : (
            <div className="flex h-full flex-col justify-between">
              {content?.length > 0 &&
                content?.map((item, index) => (
                  <div key={index}>
                    <div
                      className={` border-b border-b-bbc-neutral-500 text-center ${getKindClass(
                        index
                      )}`}
                    >
                      <p className="mb-[10px] text-[32px] font-semibold capitalize leading-[42px] tracking-[0.25px]">
                        {kind}
                      </p>
                      <p className="py-8 text-[50px] font-semibold leading-[54px] tracking-[0.25px]">
                        <span>US$</span>
                        {price}
                      </p>
                    </div>
                    <ListContent data={item} dataSuffix={dataSuffix} />
                  </div>
                ))}
              <div className="border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center">
                <a
                  href={`/onboarding/register?country_id=244&entity_type_id=${entityId}&package_id=${data.id}`}
                  className={`${
                    styles.btnAnimate
                  } ${btnColorClass()} inline-block w-full  cursor-pointer rounded-full border py-2 px-6 font-medium text-bbc-white`}
                >
                  <span>Get Started</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Component;

Component.propTypes = {
  notes: PropTypes.array,
  content: PropTypes.array,
  index: PropTypes.number,
};

Component.defaultProps = {
  notes: [],
  content: [],
  index: 0,
};

/** ========== */
